import { render, staticRenderFns } from "./need-detail.vue?vue&type=template&id=1593740f&scoped=true&"
import script from "./need-detail.vue?vue&type=script&lang=js&"
export * from "./need-detail.vue?vue&type=script&lang=js&"
import style0 from "./need-detail.vue?vue&type=style&index=0&id=1593740f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1593740f",
  null
  
)

export default component.exports